import "./DateFilter.css";
import React from "react";
import DatePill from "./DatePill";

const DateFilter = ({ highlightMap, options, value, onChange, counts = {}, offerCounts = {}, containerClassName = "pills-row" }) => {
  console.log("🔍 DateFilter reçoit counts:", counts);

  const getCount = (val) => {
    console.log(`🔍 getCount appelé avec val: "${val}" (type: ${typeof val})`);
    console.log(`🔍 counts disponibles:`, Object.keys(counts));
    console.log(`🔍 counts[${val}] = ${counts[val]}`);

    const count = val === null ? (counts["all"] ?? 0) : (counts[val] ?? 0);
    console.log(`🔍 getCount(${val}) retourne: ${count}`);
    return count;
  };

  return (
    <div
      role="radiogroup"
      aria-label="Filtrer par date"
      className={containerClassName}
    >
      {options.map((opt) => {
        const count = getCount(opt.isoDate);
        const requestedVariant = highlightMap?.get(opt.value) ?? "default";
        const variant = count > 0 ? requestedVariant : "default";

        return (
          <DatePill
            key={opt.value ?? opt.label}
            label={opt.label}
            active={value === opt.value}
            count={count}
            onClick={() => onChange && onChange(opt.value)}
            variant={variant}
            isSpecial={opt.isSpecial}
            specialType={opt.specialType}
            color={opt.color}
            offerCount={offerCounts[opt.isoDate] || 0}
          />
        );
      })}
    </div>
  );
};

export default DateFilter;
